import React from 'react';
import './styles.css';
import Views from "./components/views";

const Stores = () => {

  return (<Views/>);
};

export default Stores;